import { FORMPOST } from "../../../API/post";
import { PUT } from "../../../API/put";
import { GET } from "../../../API/get";
import { POST } from "../../../API/post";
import { disputesRef } from "../../../firebase";
import { getUserInfo } from "../../../storage";

import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { commonSwal } from "../../../components/swalAlert/swalAlert";

// export the loadMessages function which takes in dispute and dispatch as arguments
export const loadMessages = async (dispute, dispatch) => {
    try {
        if(dispute.doc_id){                                                                                      
            let query = disputesRef.doc(dispute.doc_id).collection('dispute_messages').orderBy('message_time');

            query.onSnapshot(async (snapshot) => {
                dispatch({
                    type: "IS_LOADED",
                    messages_list: snapshot.docs.map(doc => doc.data()),
                });
            });
            checkDisputeInvoicesAvailability(dispute.dispute_job.job_id, dispatch);
            await isRecallVisitArranged(dispute, dispatch);
        }
    } catch (error) {
        console.error("Error getting documents: ", error);
    }
}

// Function to send text messages
export const sendTextMessages = async (data, dispute, reset = () => {}) => {
    // Get user info
    let user_info = getUserInfo();

    // Add a new message to the messages collection
    await disputesRef.doc(dispute.doc_id).collection('dispute_messages').add({
        message_content: {
            text: data.text,
            files: [],
            text_type: (data?.text_type) ? "recall_visit" : ""
        },
        message_sender: {
            user_doc_id: user_info.admin_firebase_document_id,
            user_id: user_info.admin_id,
            user_name: user_info.admin_name,
            user_type: "ADMIN"
        },
        message_time: new Date().getTime()
    });

    // Reset the state or props as needed
    reset?.();
}

export const filePreView = (images, dispatch) => {
    let content = [];
    let count = 0;

    if (typeof images !== 'undefined') {
        for (let i = 0; i < images.length; i++) {
            content.push(
                <div className="img-wraps" key={count++}>
                    <span className="closes" title="Delete" onClick={() => removeImage(i, images, dispatch)}>×</span>
                    <img
                        src={URL.createObjectURL(images[i])}
                        style={{
                            height: "70px",
                            width: "70px"
                        }}
                        alt="Avatar"
                        className="img-responsive"
                    />
                </div>
            );
        }
    }

    return count > 0 ? content : <p><b>YOUR IMAGES</b></p>;
}

export const removeImage = (index, images, dispatch) => {
    images.splice(index, 1);

    dispatch({
        type: "SET_IMAGES",
        images: images
    });

    filePreView(images);
}

export const loadImage = (images, files, dispatch) => {
    let files_list = typeof images !== 'undefined' ? images : [];

    for (let file of files) {
        files_list.push(file);
    }

    dispatch({
        type: "SET_IMAGES",
        images: files_list
    });
}

export const sendMessageWithImages = async ({ data, dispute, images, dispatch, reset, setIsOpen }) => {
    dispatch({ type: "IS_LOADING_BTN", is_loading_btn: true });

    // Get user info
    let user_info = getUserInfo();

    let upload_images = [];
    if (images.length > 0) {
        let response = await FORMPOST("massages/files/upload", {
            images: images
        });

        if (response.status === "Success") {
            dispatch({ type: "IS_LOADING_BTN", is_loading_btn: false });
            for (let item of response.list) {
                upload_images.push({
                    path: item.image_path
                });
            }
        }
    }

    // Add a new message to the messages collection
    await disputesRef.doc(dispute.doc_id).collection('dispute_messages').add({
        message_content: {
            text: data.caption,
            files: upload_images
        },
        message_sender: {
            user_doc_id: user_info.admin_firebase_document_id,
            user_id: user_info.admin_id,
            user_name: user_info.admin_name,
            user_type: "ADMIN"
        },
        message_time: new Date().getTime()
    });

    reset();
    dispatch({
        type: "SET_IMAGES",
        images: []
    });
    setIsOpen(false);
}

export const markDisputeResolved = async (dispute, dispatch) => {
    // commonSwal({
    //     type: 'MARK_DISPUTE_RESOLVED',
    //     showCancelButton: true,
    //     showLoaderOnConfirm: true,
    //     preConfirm: async () => {
    //         let ref = disputesRef.doc(dispute.doc_id);
    //         try {
    //             // Update firestore document
    //             ref.update({
    //                 dispute_is_resolved: 1
    //             });
    
    //             // Make PUT request to close dispute
    //             let response = await PUT("close-dispute", {
    //                 dispute_job_id: dispute.dispute_job.job_id
    //             });

    //             // Check if both firestore update and PUT request were successful
    //             if (response.status === "Success") {
    //                 return ref; // Resolve the promise with ref
    //             } else {
    //                 throw new Error(response.error); // Reject the promise with an error
    //             }
    //         } catch(error) {
    //             toast.error(`Request failed: ${error.message}`);
    //         }
    //     },
    //     allowOutsideClick: () => !Swal.isLoading()
    // }).then(async (result) => {
    //     if (result.isConfirmed) {
    //         toast.success("Dispute marked as resolved.");
    //         sendTemplateMessage(3, dispute, dispatch);
    //     }
    // })
    commonSwal({
        notificationType: 'MARK_DISPUTE_RESOLVED',
        preConfirm: async () => {
            let ref = disputesRef.doc(dispute.doc_id);
            try {
                // Update firestore document
                ref.update({
                    dispute_is_resolved: 1
                });
    
                // Make PUT request to close dispute
                let response = await PUT("close-dispute", {
                    dispute_job_id: dispute.dispute_job.job_id
                });

                // Check if both firestore update and PUT request were successful
                if (response.status === "Success") {
                    return ref; // Resolve the promise with ref
                } else {
                    throw new Error(response.error); // Reject the promise with an error
                }
            } catch(error) {
                toast.error(`Request failed: ${error.message}`);
            }
        },
        isConfirmed: (result) => {
            if (result.isConfirmed) {
                toast.success("Dispute marked as resolved.");
                sendTemplateMessage(3, dispute, dispatch);
            }
        }
    })
}

export const refundJobPayment = async (event, dispute, dispatch, reset) => {
    event.preventDefault();
    let refund_amount = 0;
    if(event.target.elements.refund_amount) {
        refund_amount = parseFloat(event.target.elements.refund_amount.value);
    }

    dispatch({
        type: 'PROCESSING_REFUND',
        processing_refund: true,
        is_open_refund_job_payment_modal: true
    });

    let response = await PUT("refund-job-payment", {
        job_id: dispute.dispute_job.job_id,
        refund_type: event.target.elements.refund_type.value,
        refund_amount: refund_amount
    });

    if(response.status === "Success"){
        toast.success(response.message);
        reset();
        dispatch({
            type: 'PROCESSING_REFUND',
            processing_refund: false,
            is_open_refund_job_payment_modal: false
        });
        loadMessages(dispute, dispatch);
    }else{
        toast.error(response.message);
    }
}

const checkDisputeInvoicesAvailability = async (job_id, dispatch) => {
    try {
        const response = await GET("check-credit-note-and-sales-invoice-availability/"+job_id);
        if (response.status === "Success") {
            dispatch({
                type: 'JOB_PAYMENT_REFUNDED',
                job_payment_refunded: response.documents_available
            });
        } else {
            throw new Error(response.error);
        }
    } catch (error) {
        toast.error(`Error checking dispute invoices availability: ${error.message}`);
    }
}

export const handleRecallVisit = async (dispute, dispatch) => {
    // commonSwal({
    //     type: 'RECALL_VISIT',
    //     showCancelButton: true,
    //     showLoaderOnConfirm: true,
    //     preConfirm: async () => {
    //         return await recallVisitApi(dispute, 1)
    //     },
    //     allowOutsideClick: () => !Swal.isLoading()
    // }).then(async (result) => {
    //     if (result.isConfirmed) {
    //         const reCallVisitId = result.value.reCallVisitId;
    //         await sendTemplateMessage(1, dispute, dispatch, reCallVisitId);
    //     } else if (result.dismiss === Swal.DismissReason.cancel) {
    //         const response = await recallVisitApi(dispute, 2);
    //         const reCallVisitId = response.reCallVisitId;
    //         await sendTemplateMessage(2, dispute, dispatch, reCallVisitId);
    //     }
    // });
    commonSwal({
        notificationType: 'RECALL_VISIT',
        preConfirm: async () => {
            return await recallVisitApi(dispute, 1)
        },
        isConfirmed: (result) => {
            if (result.isConfirmed) {
                const reCallVisitId = result.value.reCallVisitId;
                sendTemplateMessage(1, dispute, dispatch, reCallVisitId);
            }
        },
        notConfirmed: (result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                const response = recallVisitApi(dispute, 2);
                const reCallVisitId = response.reCallVisitId;
                sendTemplateMessage(2, dispute, dispatch, reCallVisitId);
            }
        }
    })
}

const recallVisitApi = async (dispute, paid_type) => {
    try {
        let user_info = getUserInfo();
        let response = await POST("re-call/visit", {
            dispute_id: dispute.dispute_id,
            admin_id: user_info.admin_id,
            paid_type: paid_type
        });

        if (response.status === "Success") {
            let ref = disputesRef.doc(dispute.doc_id);
            // Update firestore document
            ref.update({
                dispute_is_resolved: 1
            });
            
            return response;
        } else {
            throw new Error(response.error);
        }
    } catch(error) {
        toast.error(`Request failed: ${error.message}`);
    }
}

const sendTemplateMessage = async (message_template_type, dispute, dispatch, reCallVisitId=0) => {
    try {
        const response = await GET("/message_template/"+message_template_type);
        if (response.status === "Success") {
            const shortCode = (reCallVisitId) ? `{{rvid_${reCallVisitId}}}` : "";
            const message = {
                text: (message_template_type !== 3 && reCallVisitId) ? response.message_template.message_template_text.concat(" ", shortCode) : response.message_template.message_template_text,
                text_type: (message_template_type !== 3 && reCallVisitId) ? "recall_visit" : ""
            };
            
            sendTextMessages(message, dispute);
            loadMessages(dispute, dispatch);
        } else {
            throw new Error(response.error);
        }
    } catch (error) {
        toast.error(`Error retrieving message template: ${error.message}`);
    }
}

const isRecallVisitArranged = async (dispute, dispatch) => {
    try {
        const response = await GET("is-recall-visit-arranged/"+dispute.dispute_id);
        if (response.status === "Success") {
            dispatch({
                type: 'IS_RECALL_VISIT_ARRANGED',
                is_recall_visit_arranged: response.isRecallVisitArranged
            });
        } else {
            throw new Error(response.error);
        }
    } catch (error) {
        toast.error(`${error.message}`);
    }
};

export const formatMessage = (message) => {
    let message_content = {
        text: message?.message_content?.text,
        recall_visit_id: 0
    };
    if(message?.message_content?.text_type === "recall_visit"){
        message_content.text = replaceRecallVisitPlaceholder(message?.message_content?.text);
        message_content.recall_visit_id = extractRecallVisitId(message?.message_content?.text);
    }
    return message_content;
};

const extractRecallVisitId = (text) => {
    const match = text.match(/{{rvid_(\d+)}}/);
    return match ? match[1] : null;
}

const replaceRecallVisitPlaceholder = (text) => {
    const recallVisitId = extractRecallVisitId(text);
    if (recallVisitId) {
        return text.replace(
            `{{rvid_${recallVisitId}}}`,
            ''
        );
    }
    
    return text;
}

export const getRecallVisitInfo = async (recallVisitId, dispatch) => {
    try {
        const response = await GET(`re-call/visit/${recallVisitId}`);
        if (response.status === "Success") {
            dispatch({
                type: 'SET_RECALL_VISIT_DATA',
                recall_visit_info: response.reCallVisit
            });
        } else {
            throw new Error(response.error);
        }
    } catch (error) {
        toast.error(`${error.message}`);
    }
};